export default "__VITE_ASSET__EilGuEeI__"